// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__19tCE","filesListContainer":"PosDisputesFiles_filesListContainer__1lJO2","filesButton":"PosDisputesFiles_filesButton__3RRUh"};